import { Component, Input } from "@angular/core";
import { LocalePickerComponent } from "../locale-picker/locale-picker.component";
import { SpinnerComponent } from "../icons/spinner/spinner.component";
import { CommonModule } from "@angular/common";
import { LogoComponent } from "../logo/logo.component";
import { NotifService } from "../../services/notif.service";
import { TranslatePipe } from "@ngx-translate/core";
import { NsLogoFooterIconComponent } from "../icons/ns-logo-footer/ns-logo-footer.component";
import { Version, VersionService } from "../../services/version.service";

@Component({
  selector: "app-layout",
  standalone: true,
  imports: [
    CommonModule,
    LocalePickerComponent,
    SpinnerComponent,
    LogoComponent,
    TranslatePipe,
    NsLogoFooterIconComponent,
  ],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.css",
})
export class LayoutComponent {
  constructor(
    public notifService: NotifService,
    public versionService: VersionService
  ) { }

  @Input()
  loading: boolean = false;

  @Input()
  type: "blue" | "white" | "yellow" = "white";

  @Input()
  size: string = "520px";
}
